import { h, render } from 'preact';
import { ShopApp } from './components-shop/ShopApp';
import { JsonProvider } from '~/components-shop/JsonProvider';

const initEshop = () => {
  const container = document.createElement('div');
  container.id = 'eshop-root';

  if (document.body.firstChild) {
    document.body.insertBefore(container, document.body.firstChild);
  } else {
    document.body.appendChild(container);
  }

  render(
    <JsonProvider>
      <ShopApp />
    </JsonProvider>,
    container
  );
};

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEshop);
} else {
  initEshop();
}
